export enum BrowserName {
  Chrome = 'Chrome',
  Edge = 'Edge',
  Firefox = 'Firefox',
  Safari = 'Safari',
  Opera = 'Opera',
  Brave = 'Brave',
  Chromium = 'Chromium',
  DuckDuckGo = 'DuckDuckGo',
  SamsungInternet = 'Samsung Internet',
  Unknown = 'Unknown',
}

export enum BrowserEngine {
  Blink = 'Blink',
  WebKit = 'WebKit',
  Gecko = 'Gecko',
  Unknown = 'Unknown',
}
